import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../../admin/common/Pagination";
import DatePicker from "react-datepicker";
import NoData from "../../admin/common/NoData";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";

const ContactUsRemarks = ({
  isShowing,
  hide,
  contactDetail,
  updateStatus,
  addNewRemarks,
}) => {
  console.log("contactDetails", contactDetail);
  console.log("Admin Info", localStorage.getItem("salesUserInfo"));

  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [statuschange, handleStatuschange] = useState(0);
  const [disable, handleDisable] = useState("disableButton");
  const [remarks, handleRemarks] = useState([]);
  const [newRemarks, handleNewRemarks] = useState(undefined);
  const [campaignId, handleCampaigId] = useState("");
  const [roId, handleroId] = useState("");
  const [rodate, handlerodate] = useState("");
  const [roAmount, handleroAmount] = useState("");
  const [showAddRemarks, handleShowAddRemarks] = useState(true);
  const [showListRemarks, handleShowListRemarks] = useState(true);

  useEffect(() => {
    console.log(contactDetail.showAddRemarks);
    contactDetail.showAddRemarks
      ? handleShowAddRemarks(contactDetail.showAddRemarks)
      : false;
    // contactDetail.remarks? handleRemarks(contactDetail.remarks):''
    contactDetail.showListRemarks ? getContactUsRemarks(0) : "";
  });

  //Fetching contact remarks list
  const getContactUsRemarks = async (skip) => {
    handleSkip(skip);
    handleShowListRemarks(false);
    contactDetail.showListRemarks = false;
    /*var adminInfo = JSON.parse(localStorage.getItem('adminInfo'));
        var paramsConstrct = {
            skip,
            email:contactDetail.email
        };*/
    /*if(localStorage.getItem('adminRole') && localStorage.getItem('adminRole') === 'stationAdmin'){
            let adminInfo = JSON.parse(localStorage.getItem('adminInfo'));
            paramsConstrct.state = adminInfo.state ? adminInfo.state : '';
        }
        try {
            const data = await Axios.get(endPoints.getContactUsRemarks,{
                params:paramsConstrct
            });
            const result = data.data.data.data;
            if (result) {
                handleRemarks(result);
            }
        } catch (error) {
            console.log(error);
        }*/
    handleRemarks([]);
    handleCount(0);
    if (contactDetail.remarks) {
      // console.log("contactDetail.remarks",contactDetail.remarks);
      let remarksCount = 0;
      // console.log("((contactDetail.remarks).length)%5",((contactDetail.remarks).length)%5);
      if (contactDetail.remarks.length % 5 == 0) {
        remarksCount = contactDetail.remarks.length + 1;
      } else {
        remarksCount = contactDetail.remarks.length;
      }
      // console.log("remarksCount",remarksCount);
      handleCount(remarksCount);
      let remarkList = contactDetail.remarks;
      let start = skip == 0 ? 0 : skip;
      let end = skip == 0 ? 5 : skip + 5;
      console.log("skip", skip);
      console.log("start", start);
      console.log("end", end);
      let paginationList = remarkList.slice(start, end);
      console.log("paginationList>>", paginationList);
      handleRemarks(paginationList);
    } else {
      handleRemarks([]);
      handleCount(0);
    }
  };

  const closePopup = () => {
    hide();
    handleStatuschange();
    handleRemarks([]);
    handleCount(0);
    handleSkip(0);
  };

  const getRemarks = (e) => {
    console.log(e.target.value);
    handleNewRemarks(e.target.value);
  };

  const handleContactsUsRemarks = (e) => {
    e.preventDefault();
    console.log("Admin Info", localStorage.getItem("salesUserInfo"));
    let adminInfo = JSON.parse(localStorage.getItem("salesUserInfo"));
    if (!newRemarks) {
      toast.error("Please enter remarks ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "3",
      });
      return;
    }
    if (!campaignId && contactDetail.status === "Converted online") {
      toast.error("Please enter campaign id ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "3",
      });
      return;
    }
    if (!roId && contactDetail.status === "Converted offline") {
      toast.error("Please enter RO ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "3",
      });
      return;
    }
    if (!rodate && contactDetail.status === "Converted offline") {
      toast.error("Please enter Ro Date", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "3",
      });
      return;
    }
    if (!roAmount && contactDetail.status === "Converted offline") {
      toast.error("Please enter Ro Amount", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "3",
      });
      return;
    }
    let params = {
      _id: contactDetail._id,
      remarks: newRemarks,
      user: adminInfo.name,
      user_email: adminInfo.email,
      status: contactDetail.status,
    };
    debugger;
    if (contactDetail.status === "Converted online") {
      params["campaignId"] = campaignId;
    }
    if (contactDetail.status === "Converted offline") {
      params["roId"] = roId;
      params["roDate"] = rodate;
      params["roAmount"] = roAmount;
    }
    let param = {
      _id: contactDetail._id,
      assignee: contactDetail.assignee,
      status:
        contactDetail.status == "Future Plan"
          ? "Follow Up"
          : contactDetail.status,
    };
    addNewRemarks(params);
    updateStatus(param);
  };

  return isShowing ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup remarks-popup"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <div className="modal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true" style={{ fontSize: 48 }}>
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  Remarks{" "}
                  {contactDetail.showAddRemarks === true && (
                    <span>Changes</span>
                  )}
                </h4>
              </div>
              <div className="editNonFct-modal modal-body">
                <div className="bg-white">
                  <form className="form-group">
                    <div className="popupCampaign-container">
                        <div style={{marginBottom: "5px"}}>
                      <label className="static-value">Remarks </label>
                      
                            <textarea
                            style={{
                                border: "1px solid rgba(0, 0, 0, 0.3)",
                                borderRadius: "5px",
                                width: "100%",
                                height:"60px",
                                paddingLeft: "15px",
                              }}
                              id="outlined-basic"
                              label="Remarks"
                              onChange={getRemarks}
                            />
                        </div>
                      {contactDetail.status === "Converted online" && (
                         <div style={{marginBottom: "5px"}}>
                         <label className="static-value">Campaign Id </label>
                
                         
                               <input
                               type="text"
                               style={{
                                   border: "1px solid rgba(0, 0, 0, 0.3)",
                                   borderRadius: "5px",
                                   width: "100%",
                                   height:"35px",
                                   paddingLeft: "15px",
                                 }}
                                 onChange={(e)=>{
                                    handleCampaigId(e.target.value)
                                }}
                                 id="outlined-basic"
                               />
                           </div>
                      )}
                      {contactDetail.status === "Converted offline" && (
                        <React.Fragment>
                                <div style={{marginBottom: "5px"}}>
                         <label className="static-value">Ro Id </label>
                               <input
                               type="text"
                               style={{
                                   border: "1px solid rgba(0, 0, 0, 0.3)",
                                   borderRadius: "5px",
                                   width: "100%",
                                   height:"35px",
                                   paddingLeft: "15px",
                                 }}
                                 onChange={(e)=>{
                                    handleroId(e.target.value)
                                }}
                                 id="outlined-basic"
                               />
                           </div>
                           <div style={{marginBottom: "5px"}}>
                         <label className="static-value">Ro Amount </label>
                               <input
                               type="number"
                               style={{
                                   border: "1px solid rgba(0, 0, 0, 0.3)",
                                   borderRadius: "5px",
                                   width: "100%",
                                   height:"35px",
                                   paddingLeft: "15px",
                                 }}
                                 id="outlined-basic"
                                 onChange={(e)=>{
                                    handleroId(e.target.value)
                                }}
                               />
                           </div>
             
                          <div className="campaign-input master-inputs nonFct">
                            <div className="input-tag signup-tag clearfix fct-input">
                              <label className="static-value">Ro Date </label>
                              <DatePicker
                                // placeholderText="Ro Date"
                                // dateFormat="h:mm a"
                                onChange={handlerodate}
                                selected={rodate}
                                // className="form-control"
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                      <div className="save_details" style={{textAlign:"center", marginBottom:"3%"}}>
                        <button onClick={handleContactsUsRemarks}>
                          SAVE CHANGES
                        </button>
                        <button onClick={closePopup}>Cancel</button>
                      </div>
                      <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                        <table
                          className={
                            remarks.length > 0
                              ? "table table-striped master-table contact_list"
                              : "table table-striped master-table contact_list none"
                          }
                        >
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Remarks</th>
                              <th>Added By</th>
                            </tr>
                          </thead>
                          <tbody>
                            {remarks &&
                              remarks.map((r, i) => (
                                <tr key={i}>
                                  <td>
                                    {moment(r.date).format(
                                      "DD/MM/YYYY hh:mm:A"
                                    )}
                                  </td>
                                  <td>{r.status}</td>
                                  <td className="msg_text">{r.remark}</td>
                                  <td>
                                    {r.user}
                                    <br />
                                    {r.user_email}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="paginationTable">
                          {count >= 6 && (
                            <Pagination
                              getAllData={getContactUsRemarks}
                              limit={5}
                              totalRecords={count}
                            />
                          )}
                        </div>
                      </div>
                      {remarks.length === 0 ? <NoData /> : null}
                      {/*<div className="create-camp nonfct-submit">
                  <button onClick={handleContactsUsRemarks}>SAVE CHANGES</button>
                </div>*/}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default ContactUsRemarks;



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/viewContantDetails.js